import { Component } from '@angular/core';

@Component({
  selector: 'whatsapp-app',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.css']
})
export class WhatsappWidgetComponent {
}
